import { Popover as _Popover, PopoverProps } from 'antd5';
import { useTheme } from 'styled-components';
import { Theme } from 'utils/color/horizonTheme';

export const Popover = (props: PopoverProps) => {
  const theme = useTheme();
  return (
    <_Popover
      arrow={{ pointAtCenter: true }}
      color={
        theme.themeName === Theme.Dark ? theme.tooltipBackground : theme.secondaryBackgroundColor
      }
      {...props}
    >
      {props.children}
    </_Popover>
  );
};
